import React, { useContext } from "react";
import LogoLabel from "components/ui-components/LogoLabel";
import { CommonContext } from "hooks/CommonContext";
import ProfileLaterIcon from "components/ui-components/ProfileLaterIcon";

const STYLES = `
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');

  .join-page-header {
    display: flex !important;
    align-items: center !important;
    justify-content: space-between !important;
    height: 56px !important;
    padding: 0 24px !important;
    background: #0b1120 !important;
    border-bottom: 1px solid #1a2540 !important;
    font-family: 'Inter', system-ui, sans-serif !important;
    flex-shrink: 0 !important;
    z-index: 100 !important;
    box-sizing: border-box !important;
  }

  .jh-left {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .jh-beta {
    font-size: 9px;
    font-weight: 700;
    letter-spacing: 0.09em;
    text-transform: uppercase;
    color: #22d3ee;
    background: rgba(34, 211, 238, 0.08);
    border: 1px solid rgba(34, 211, 238, 0.22);
    border-radius: 5px;
    padding: 2px 7px;
    line-height: 1.5;
  }

  .jh-right {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .jh-username {
    font-size: 13px;
    font-weight: 500;
    color: #8b9dc3;
    text-align: right;
    line-height: 1.3;
  }

  @media (max-width: 480px) {
    .join-page-header { padding: 0 14px !important; }
    .jh-username      { display: none; }
  }
`;

let _inj = false;
const inject = () => {
  if (_inj) return;
  const s = document.createElement("style");
  s.textContent = STYLES;
  document.head.appendChild(s);
  _inj = true;
};

const JoinHeader = () => {
  inject();
  const { userOwnData } = useContext(CommonContext);

  return (
    <div className="join-page-header">
      <div className="jh-left">
        <LogoLabel />
        <span className="jh-beta">BETA</span>
      </div>
      <div className="jh-right">
        {userOwnData.username && (
          <div className="jh-username">{userOwnData.username}</div>
        )}
        <ProfileLaterIcon
          latter={(userOwnData.fname?.charAt(0) ?? "") + (userOwnData.lname?.charAt(0) ?? "")}
          colorCode={userOwnData.colorCode}
        />
      </div>
    </div>
  );
};

export default JoinHeader;